import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { downloadImportTemplate } from '@/api/clientImports/clientImportsApi';
import { saveDownloadedFile, type DownloadedFile } from '@/api/fileDownload';

export function useDownloadImportTemplate(): UseMutationResult<DownloadedFile, Error, void> {
  return useMutation({
    mutationFn: downloadImportTemplate,
    onSuccess: saveDownloadedFile,
  });
}
